import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 39 41"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#i-467572959__a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FA7E14",
    d: "M19.593 21.546c-.146.209-.27.38-.388.554a42939.81 42939.81 0 0 0-5.68 8.38c-1.76 2.598-3.524 5.195-5.288 7.79a.357.357 0 0 1-.251.147 1674.55 1674.55 0 0 1-7.471-.081c-.028 0-.057-.009-.11-.017.02-.052.043-.103.069-.152l5.212-8.097c1.541-2.392 3.083-4.783 4.626-7.173 1.71-2.656 3.419-5.314 5.127-7.973.252-.393.514-.777.754-1.177a.486.486 0 0 0 .051-.353c-.46-1.47-.93-2.938-1.398-4.405-.2-.628-.41-1.253-.599-1.885-.06-.203-.16-.265-.368-.264-1.565.007-3.12.005-4.68.005-.297 0-.298 0-.298-.293 0-1.923 0-3.846-.006-5.769 0-.214.07-.262.27-.262 3.143.006 6.285.006 9.428 0a.302.302 0 0 1 .33.224 53674.845 53674.845 0 0 0 10.771 27.132c.6 1.512 1.205 3.022 1.8 4.537.07.184.144.22.33.162 1.646-.51 3.297-1.006 4.943-1.517.207-.065.283-.022.347.184.562 1.769 1.134 3.534 1.703 5.3.02.062.034.123.057.208-.118.044-.228.093-.341.124a18192.41 18192.41 0 0 0-11.225 3.569c-.178.056-.232-.005-.291-.155-1.143-2.901-2.287-5.8-3.435-8.699l-3.37-8.514-.502-1.28c-.027-.073-.064-.137-.117-.25"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "i-467572959__a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 .5h39v40H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }